module.exports = __webpack_public_path__ + "img/ico-twitter.3ae2813e.svg";